<template>
  <div class="btn-group-vertical cmd-group">
    <button
      class="btn btn-outline-danger cmd-button"
      type="button"
      @click="disableIgnition"
    >
      Отключить зажигание
    </button>
    <button
      class="btn btn-light cmd-button"
      type="button"
      @click="enableIgnition"
    >
      Включить зажигание
    </button>
    <button class="btn btn-light cmd-button" type="button" @click="anyCommand">
      Произвольная команда
    </button>
    <button
      class="btn btn-light cmd-button"
      type="button"
      @click="setConfigCommand"
    >
      Быстрое конфигурирование
    </button>
  </div>
</template>
<script>
import Swal from 'sweetalert2'
import { mapGetters } from 'vuex'
import commandsAPI from '@/api/commands'
export default {
  name: 'MapCardCommands',
  computed: {
    ...mapGetters('taxi/mapcars', [
      'getSelected'
    ])
  },
  methods: {
    disableIgnition () {
      Swal.fire({
        title: 'Отключить зажигание?',
        showCancelButton: true,
        confirmButtonText: 'Отправить',
        cancelButtonText: 'Назад'
      }).then((result) => {
        if (result.value) {
          commandsAPI.lockIgnition({ imei: this.getSelected.imei })
            .then(answer => this.deviceAnswer(answer.result.response))
        }
      })
    },
    enableIgnition () {
      commandsAPI.unlockIgnition({ imei: this.getSelected.imei })
        .then(answer => this.deviceAnswer(answer.result.response))
    },
    anyCommand () {
      Swal.fire({
        customClass: {
          container: 'over-swal'
        },
        title: 'Введите комманду',
        input: 'text',
        inputValidator: (value) => {
          if (!value) {
            return 'Команда не может быть пустой!'
          }
        }
      }).then(command => {
        if (!command.dismiss) {
          commandsAPI.sendCommand({ imei: this.getSelected.imei, command: command.value })
            .then(answer => this.deviceAnswer(answer.result.response))
        }
      })
    },
    setConfigCommand () {
      commandsAPI.fastConfig({ imei: this.getSelected.imei })
        .then(answer => this.deviceAnswer(answer.result.response))
    },
    deviceAnswer (answer) {
      Swal.fire({
        customClass: {
          container: 'over-swal'
        },
        title: 'Ответ устройства',
        text: answer
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .cmd-button {
    margin-bottom: 0.2rem;
  }
  .cmd-group {
    width: 100%;
  }
</style>
